import api from './api';

export interface Message {
  id: number;
  subject: string;
  sender: string;
  senderEmail: string;
  content: string;
  timestamp: string;
  type: 'email' | 'chat' | 'notification' | 'phone';
  priority: 'high' | 'medium' | 'low';
  isRead: boolean;
  hasAttachment: boolean;
  project?: string;
  threadId?: string;
}

export interface GetCommunicationsParams {
  type?: 'all' | 'unread' | 'email' | 'chat' | 'notification' | 'phone';
  search?: string;
}

class CommunicationService {
  /**
   * Get all communications for the current PM
   */
  async getCommunications(params?: GetCommunicationsParams): Promise<Message[]> {
    const response = await api.get<{ success: boolean; data: Message[] }>(
      '/messages/communications',
      { params }
    );
    return response.data.data;
  }

  /**
   * Mark a communication as read
   */
  async markAsRead(messageId: number): Promise<void> {
    await api.patch(`/messages/communications/${messageId}/read`);
  }
}

export default new CommunicationService();
